<template>
  <div>
    <van-tabs v-model="active" line-height="2px" color="#45B9BC" sticky :swipe-threshold="6" title-active-color="#45B9BC"  @click="change_order()">
        <van-tab v-for="(tabItem,tabIndex) in tabList" :key="tabIndex">
          <!--标签标题栏-->
          <div slot="title">{{tabItem.title}}</div>
          <!--订单为空-->
          <div class="order__emptyBox" v-if="order_none==0">
            <img src="../../../../static/img/order_empty.png" alt="">
            <p>暂无订单，快去逛逛吧~</p>
          </div>
          <!--订单内容-->
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" v-else>
            <div class="order__listBox">
              <router-link :to="{path:'/store_orderDetails',query:{'id':orderItem.id}}" class="order__list" v-for="(orderItem,orderIndex) in tabItem.orderList" :key="orderIndex">
                <div class="order__list_title flex">
                  <span>订单号：{{orderItem.ordersn}}</span>
                  <span class="col_45B9BC" v-if="orderItem.status == 0">待付款</span>
                  <span class="col_45B9BC" v-if="orderItem.status == 1">待接单</span>
                  <span class="col_45B9BC" v-if="orderItem.status == 2">待服务</span>
                  <span class="col_45B9BC" v-if="orderItem.status == 3">已核销</span>
                  <span class="col_45B9BC" v-if="orderItem.status == 4 ">已取消</span>
                  <span class="col_45B9BC" v-if="orderItem.status == -1 ">已取消</span>
                </div>
                <div class="order__list_content">
                  <div class="flex"><span>{{orderItem.servicetitle}}</span><span>¥{{orderItem.price}}</span></div>
                  <div class="fs_12 order__content_subtitle">
                    <p class="col_999">预约时间：{{orderItem.starttime}}</p>
                    <!-- <p v-if="orderItem.type==='1'" class="col_45B9BC">距离服务时间还剩：{{orderItem.surplus_time}}</p> -->
                  </div>
                  <div class="order__content_btnBox">
                    <router-link :to="{path:'/store_orderDetails',query:{'id':orderItem.id}}" class="order__btn2">查看详情</router-link>
                  </div>
                </div>
                </router-link>
            </div>
          </van-list>
        </van-tab>
      </van-tabs>
  </div>
</template>

<script>
  import tabBar from "@/components/tabBar.vue";
  export default {
    name: "store_order",
    components: { tabBar },
    data(){
      return{
        order_none:0,
        status:0,
        active:0,
        page:0,
        loading: false,
        finished: false,
        order_total:0,
        // 订单列表
        tabList:[
          {
            title:'全部',
            // 加载更多
           
            status:0,
            orderList:[
            ]
          },{
            title:'待接单',
            // 加载更多
       
            status:1,
            orderList:[
            ]
          },{
            title:'待服务',
            // 加载更多
     
            status:2,
            orderList:[
            ]
          },{
            title:'已核销',
            // 加载更多
        
            status:3,
            orderList:[
            ]
          },{
            title:'已取消',
            // 加载更多
    
            status:-1,
            orderList:[
            ]
          },
          ]
      }
    },
    created(){
        this.status  = this.$route.query.status
        this.active  =this.status        
        if (this.status == -1) {
          this.active = 4;
        }    
        this.get_store_order();
    },
    methods:{
      // 加载数据
      onLoad() {
        // 异步更新数据
        setTimeout(() => {
          // 定义当前所在的数组
          var tabList_active=this.tabList[this.active];
          // 定义一个变量，取出当前数组的里的list
          var list=tabList_active['orderList'];
         this.loading  =false;
          // 加载状态结束
           if ( list.length >= this.order_total) {
             this.finished = true
          }else{
              this.page =this.page+1;         
             this.get_store_order();
          }

         
        }, 500);
      },
      get_store_order(){
        this.status = this.active
        if (this.active == 4) {
          this.status = -1;
        } 
        var that = this;     
        this.axios({
          url: this.api.store.store_order,
          data: {status:this.status,page:this.page}
        }).then(res => {
          if (res.error === 0) {
            this.order_total = res.store_order_total;
            for(let i=0;i<res.order.length;i++){
                that.tabList[that.active].orderList.push(res.order[i]);
            }
            
            if(res.order.length>0){
                that.order_none = 1
            }
             this.loading = false
          if ( that.tabList[that.active].orderList.length >= this.order_total) {
              this.finished = true
            }
          }
        });
      },
      change_order(){
          this.order_none=0; 
          this.page = 0;
          this.finished= false;
          this.loading = true;
          this.tabList[this.active].orderList= [];  
          this.get_store_order();
      },
    },
  }
</script>

<style scoped>
  @import "../../../assets/css/order.css";
</style>



// WEBPACK FOOTER //
// src/views/store/order/store_order.vue